// 人员管理
import {contractApi} from "@/axios";
//获取人员信息
export function getPersonByType(param,data){
    if(param){
        return contractApi({
            url:'/personnel/list/' + param,
            method:'post',
            data: data
        })
    }else{
        return contractApi({
            url:'/personnel/list',
            method:'post',
            data: data
        })
    }
}
//获取自己及下属名单
export function getPersonById(param,data){
    return contractApi({
        url:'/personnel/getMeAndUnderlingByUuid/' + param,
        method:'post',
        data: data
    })
}
//获取评估人名单
export function getEvaluators(){
    return contractApi({
        url:'/personnel/get-evaluators',
        method:'get',
    })
}
//信息统计
export function informationStats(param,data){
    if(param === 'SALES_STATS'){
        return contractApi({
            url:'/statistics/sales/sales-stats',
            method:'post',
            data: data
        })
    }else if (param === 'COMPANY_STATS') {
        return contractApi({
            url:'/statistics/sales/company-stats',
            method:'post',
            data: data
        })
    }else if (param === 'MATERIAL_IN_OUT_STATS') {
        return contractApi({
            url:'/statistics/sales/material-stats',
            method:'post',
            data: data
        })
    } else if (param === 'SALES_WEEK_STATS') {
        return contractApi({
            url: '/statistics/sales/sales-date-stats',
            method: 'post',
            data: data
        })
    } else {
        return contractApi({
            url:'/statistics/sales/sales-material-stats',
            method:'post',
            data: data
        })
    }
}
//信息导出
export function exportStats(params,data){
    return contractApi({
        url:'/statistics/sales/export',
        method:'post',
        params:params,
        data: data,
        responseType: 'blob', // 设置响应类型为 blob
    })
}